import { Types } from '@/shims/mongoose';

/** Normalizes any id flavour (string, ObjectId, number) to the string form used across the UI. */
export function toId(value: unknown): string {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value);
}

/** Single place where new group ids are minted (24-char hex ObjectId, no mongoose dependency). */
export function createGroupId(): string {
  return new Types.ObjectId().toHexString();
}

/** Set of the string ids found across group lists (missing lists and ids are skipped). */
export function collectGroupIds(...lists: ({ _id?: unknown }[] | undefined)[]): Set<string> {
  return new Set(lists.flatMap(list => (list ?? []).map(group => toId(group._id)).filter(Boolean)));
}
